(function($,window){


    var filter_blanket = function(_form){


        var s = this;
        s.searchInput = _form.find('input.search');
        s.searchButton = _form.find('input[type="button"]');
        s.categories = _form.find('ul');
        s.filter = {
            searchText : s.searchInput.val(),
            categories : s.categories.find('li.active').length === 0 ? 0 : s.categories.find('li.active').attr("data-id"),
            type : 'search'
        };

        var errorMsg = new message("danger");

        s.init = function(){

            s.post_data = {
                url: m4.ajax_url,
                type : 'POST',
                data: {action:'get_filtered_blanket_form',filter : s.filter,nonce:m4.nonce},
                success:s.ajax_response
            };

            s.searchInput.on('change keyup',s.updateFilter);
            s.categories.find('li').on('click',s.updateFilter);
            s.searchButton.on('click',s.btnClick);
        };

        s.btnClick = function(e){
            e.preventDefault();
            s.filter.searchText = s.searchInput.val();

            if(s.filter.searchText == ""){
                errorMsg.removeAllMsg();
                errorMsg.createMessage("Ange ett sökvärde");
                errorMsg.display();
                return;
            }

            s.categories.find('li').removeClass('active');
            s.filter.type = 'search';
            s.filter.categories = [];
            s.fetchCategoriesPosts();
        };

        s.updateFilter = function(e){

            var element = $(this);
            var oldFilter = jQuery.extend({}, s.filter);

            if(typeof e !== undefined && e.type === 'click'){
                s.categories.find('li').removeClass('active');
                element.addClass('active');
                s.filter.categories = $(this).attr("data-id");
                s.filter.searchText = $(this).text();
                s.filter.type = 'categories';
                
                if(s.filter.categories === "show_all"){
                    s.filter.type = 'all';
                }

                if(JSON.stringify(s.filter) !== JSON.stringify(oldFilter)){
                    s.fetchCategoriesPosts();
                }
            }else{
                s.filter.searchText = $(this).val();
                s.filter.type = 'search';
                if(typeof e !== undefined && e.type === 'keyup' && e.key === 'Enter'){
                    if(s.filter.searchText == ""){
                        errorMsg.removeAllMsg();
                        errorMsg.createMessage("Ange ett sökvärde");
                        errorMsg.display();
                        return;
                    }
                    s.categories.find('li').removeClass('active');
                    s.fetchCategoriesPosts();
                }
            }

        };


        

        s.fetchCategoriesPosts = function(){
            _form.find(".alert").hide();
            $("#filter_result > .load").fadeIn();
            $("#filter_result > #html").css({opacity:0.5});
            $.ajax(s.post_data); 
        };

        s.ajax_response = function(data, textStatus, jqXHR){
            $("#filter_result > .load").slideUp();
            if(typeof data === "object"){
                if(data.success){
                  $("#filter_result > #html").html(data.data.html);
                   $("#filter_result > #html").css({opacity:1});
                  $(window).trigger("stretch"); 
                  return true;
                }
            }
            $("#filter_result > #html").css({opacity:1});
            $("#filter_result > #html").html(' '); 
            _form.find(".alert").slideDown();

        };

        s.init();

        return s;

    };

    //Init filter
    $(document).ready(function(){

        var form = $('body').find('.filter_blanket');

        //Check if we have filter
        if(form.length === 0) return false;

        new filter_blanket(form);

    });

})(jQuery,window);